import * as yup from 'yup';

export const validationSchemaRectificativaTotal = yup.object().shape({
  ConceptoRectificacionACero: yup.string().required('El concepto de la rectificativa es obligatorio'),
});
